module.exports = __webpack_public_path__ + "media/index/page-background-2ca84267.jpg";